<template>
	<div class="container">
		<div class="row justify-content-md-center">
			<div class="col-sm-10">
				<div class="card mb-3">
					<div class="card-body">
						<form @submit.prevent="cargar" method="post" enctype="multipart/form-data">
							<div class="form-row">
								<div class="col-md-1 mb-3">
									<a
										href="/public/saldos_bazar.csv"
										class="btn btn-success btn-block"
										title="Descargar plantilla"
										download
									>CSV</a>
								</div>
								<div class="col-md-7 mb-3">
									<div class="custom-file">
										<input
											type="file"
											class="custom-file-input"
											id="customFile"
											accept=".csv"
											@change="setArchivo"
											required
										>
										<label class="custom-file-label" for="customFile">Seleccionar Archivo</label>
									</div>
								</div>
								<div class="col-md-2 mb-3">
									<select class="form-control" v-model="separador" required>
										<option value="">- Separador -</option>
										<option value=",">Coma (,)</option>
										<option value=";">Punto y coma (;)</option>
									</select>
								</div>
								<div class="col-md-2 mb-3">
									<button
										class="btn btn-primary btn-block"
										type="submit"
										:disabled="enviando"
									>
										<template v-if="enviando">
											<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
											<span class="sr-only">Loading...</span>
										</template>
										<template v-else>
											Cargar
										</template>
									</button>
								</div>
							</div>
						</form>

						<div class="alert alert-danger" role="alert" v-if="errores.length > 0">
							<h4 class="alert-heading">Errores encontrados:</h4>
							<ul>
								<li v-for="(i, idx) in errores" :key="idx">{{ i.mensaje }}</li>
							</ul>
						</div>

						<div class="alert alert-success" role="alert" v-if="exito">
							<h4 class="alert-heading">¡Bien hecho!</h4>
							<p class="mb-0">{{ exitoTxt }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'BazarSaldo',
	data: () => ({
		archivo: '',
		separador: '',
		enviando: false,
		errores: [],
		exito: false,
		exitoTxt: ''
	}),
	methods: {
		setArchivo (e) {
			this.archivo = e.target.files[0];
		},
		cargar () {
			this.enviando = true
			this.errores = []
			this.exito = false
			this.exitoTxt = ''

			const datos = new FormData()
			datos.append('archivo', this.archivo);
			datos.append('separador', this.separador);

			axios.post(this.UrlBase+'/usuario/saldo', datos)
			.then(res => {
				this.enviando = false
				this.exito = true
				this.exitoTxt = res.data.mensaje
			})
			.catch(error => {
				if (error.response.data.errores !== undefined) {
					this.errores = error.response.data.errores
				} else {
					this.errores = [{
						codigo: 0,
						mensaje: error
					}]
				}

				this.enviando = false
			})
			
		}
	}
}
</script>
